import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import { Label, Input, Row, Col } from "reactstrap";
import ManagerRequirementsModal from "../../../components/Modals/ManagerRequirementsModal";

const ManagerSection = ({
  managerData,
  setManagerData,
  isManagerRedirect,
  managerRequirementsModal,
  setManagerRequirementsModal,
  email,
  setEmail,
}) => {
  const fileInputRef = useRef(null);
  const [imgHovered, setImgHovered] = useState(false);

  const handleRemovePhoto = () => {
    setManagerData((prev) => ({ ...prev, photo: "" }));
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleToggle = (isCurrentlyManager) => {
    if (isManagerRedirect && isCurrentlyManager) {
      toast.info(
        "Manager mode is locked when redirected from another site. Please complete signup to become a manager."
      );
      return;
    }
    if (!isCurrentlyManager) {
      setManagerRequirementsModal(true);
    } else {
      setManagerData((prev) => ({ ...prev, isManager: false }));
    }
  };

  const handleAccept = () => {
    setManagerData((prev) => ({ ...prev, isManager: true }));
    setManagerRequirementsModal(false);
    if (isManagerRedirect) {
      toast.success("Great! You're now set to become a manager. Please complete the registration form.");
    }
  };

  const handleDecline = () => {
    if (isManagerRedirect) {
      toast.warning(
        "You were redirected to become a manager. If you don't want to be a manager, please navigate to the regular registration page."
      );
      return;
    }
    setManagerRequirementsModal(false);
  };

  return (
    <>
      <Row className="mt-3">
        <Col>
          <p className="edit-password-info">Do you want to be a Manager?</p>
          {isManagerRedirect && (
            <small className="text-info">
              <i className="fas fa-lock mr-1"></i>
              Manager mode is enabled
            </small>
          )}
        </Col>
        <Col>
          <p className="edit-password-info">
            <div className="switchBtnContainer">
              <div
                className="switchBtn"
                style={{
                  backgroundColor: managerData.isManager ? "#4caf50" : "#f44336",
                  opacity: isManagerRedirect ? 0.7 : 1,
                  cursor: isManagerRedirect ? "not-allowed" : "pointer",
                }}
                onClick={() => handleToggle(managerData.isManager)}
              >
                <div
                  className="switchBtnSlider"
                  style={{ left: managerData.isManager ? "26px" : "2px" }}
                />
              </div>
              <span className="switchBtnLabel">
                {managerData.isManager ? "Yes" : "No"}
              </span>
            </div>
          </p>
        </Col>
      </Row>

      {managerData.isManager && (
        <>
          <h2 className="auth-heading">Manager Data</h2>
          <div className="d-flex flex-column align-items-start mt-2">
            <Label className="auth-label mt-4">Photo ID</Label>
            <Input
              type="file"
              required
              name="player_img"
              accept="image/png, image/gif, image/jpeg"
              style={{ width: "100%" }}
              innerRef={fileInputRef}
              onChange={(e) =>
                setManagerData((prev) => ({ ...prev, photo: e.target.files[0] }))
              }
            />
            {managerData.photo && (
              <div
                style={{ position: "relative", marginTop: "12px", display: "inline-block" }}
                onMouseEnter={() => setImgHovered(true)}
                onMouseLeave={() => setImgHovered(false)}
              >
                <img
                  src={URL?.createObjectURL(managerData.photo)}
                  alt="Photo ID preview"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    borderRadius: "8px",
                    border: "1px solid #dee2e6",
                    display: "block",
                  }}
                />
                {imgHovered && (
                  <button
                    type="button"
                    onClick={handleRemovePhoto}
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      margin: "auto",
                      width: "32px",
                      height: "32px",
                      background: "rgba(0,0,0,0.6)",
                      border: "none",
                      borderRadius: "50%",
                      color: "#fff",
                      fontSize: "18px",
                      lineHeight: "1",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    aria-label="Remove photo"
                  >
                    &times;
                  </button>
                )}
              </div>
            )}
          </div>

          <Label className="mt-5 auth-label mb-0">Email</Label>
          <Input
            required
            placeholder="name@gmail.com"
            type="email"
            className="custom-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <Label className="mt-5 auth-label mb-0">Description</Label>
          <Input
            required
            placeholder="Enter description"
            type="textarea"
            className="custom-input"
            value={managerData.description}
            onChange={(e) =>
              setManagerData((prev) => ({ ...prev, description: e.target.value }))
            }
          />
        </>
      )}

      <ManagerRequirementsModal
        isOpen={managerRequirementsModal}
        toggle={handleDecline}
        onAccept={handleAccept}
        isManagerRedirect={isManagerRedirect}
      />
    </>
  );
};

export default ManagerSection;
